import { render } from "./EspecificacionesInv.vue?vue&type=template&id=c4f4f6f8&scoped=true"
import script from "./EspecificacionesInv.vue?vue&type=script&lang=js"
export * from "./EspecificacionesInv.vue?vue&type=script&lang=js"

import "./EspecificacionesInv.vue?vue&type=style&index=0&id=c4f4f6f8&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f4f6f8"]])

export default __exports__